import type { ProjectPostSearchCommand, ProjectPostSearchResponse } from '../entity/ProjectTypes';
import type { ProjectRepository } from '../repository/ProjectRepository';

export class SearchProjectPostsUseCase {
  constructor(private projectRepository: ProjectRepository) {}

  async execute(command: ProjectPostSearchCommand): Promise<ProjectPostSearchResponse> {
    return this.projectRepository.searchProjectPosts(command);
  }
}
